
export const handleRestartApp = async() => {
    // ---------------------------------
    try {
      // 1. Clear storage
      localStorage.clear();
      sessionStorage.clear();
  
      // 2. Unregister service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }
      }
  
      // 3. Clear any caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        for (const name of cacheNames) {
          await caches.delete(name);
        }
      }
    } finally {
      // 4. Reload page
      window.location.reload();
    }
  }